import { styled } from "@material-ui/core";
import { Box } from "@mui/material";

export const MainCont =  styled(Box)(({theme})=>({
    height: '100%',
    width: '100%',
    borderRadius: '10px',
    backgroundColor: 'transparent !important'
    // '& *': {
    // }
}));